import { render } from "./CalendarioHoy.vue?vue&type=template&id=66df5516&scoped=true"
import script from "./CalendarioHoy.vue?vue&type=script&lang=js"
export * from "./CalendarioHoy.vue?vue&type=script&lang=js"

import "./CalendarioHoy.vue?vue&type=style&index=0&id=66df5516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df5516"]])

export default __exports__